<template>
  <div id="services-page-top">
    <ServicesBanner></ServicesBanner>
    <div class="container-fluid page text-light bg-dark" id="services-page-container">
      <div class="row flex-xl-nowrap">
        <div class="col-12 col-xl-10">
          <div data-spy="scroll" data-target="#services-nav" data-offset="0">
            <h1 class="display-2 pb-5">About Our Services</h1>
            <hr>
            <h1 class="display-4" id="paintless-dent-repair" ref="paintless-dent-repair">Paintless Dent Repair</h1>
            <h2 id="tools" ref="tools">Tools</h2>
            <p>
              When access permits, most dents are repaired with specialty hand tools. These tools come in many different sizes and each has a unique shape and design for various panels on the vehicle. Although two tools may appear to be very different they all share the same function, the ability to apply pressure and "push" the dent. Depending on the size and severity it could take hundreds of precise "pushes" to repair a single dent. This method reverses the damage and results in the cleanest repair possible. An unskilled or unexperienced technician can possibly crack the paint by using too much force. An unskilled technician will also apply pressure to the wrong part of the dent or use too much force resulting in a repair that appears to have a rough or wavy texture. A successful PDR repair will not have an abnormal texture, the clear coat should match the surrounding area.
            </p>
            <div class="card-deck">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/start-0.jpg" alt="Special tools are used to reach dents over panel braces">
                <div class="card-body">
                  <p class="card-text small">Special tools are used to reach dents over panel braces</p>
                </div>
              </div>
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/start-1.jpg" alt="Dents are massaged back out from the underside of the panel">
                <div class="card-body">
                  <p class="card-text small">Dents are massaged back out from the underside of the panel</p>
                </div>
              </div>
            </div>
            <h2 id="glue-pulling" ref="glue-pulling">Glue Pulling</h2>
            <p>
              Glue pulling refers to using a high temperature glue and a special plastic "tab" to pull on the dent. The high-temp glue is specially made for automotive finishes and comes in various formulas for temperature and humidity of the working environment. Glue pulling is not recommended for older vehicles or refinished panels, cold temperatures are not recommended as well. In some situations access to the underside of the dent may be impossible and a tool cannot be used. By gluing a plastic tab to the metal, a skilled technician can manipulate the metal by pulling on it with special tools. Once the pull has been made the glue can be safely released with Isopropyl alcohol leaving the finish unharmed. This technique combined with blending will result in a clean repair where there is little or no tool access.
            </p>
            <div class="card-deck">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/sequence-0.jpg" alt="A blending hammer is first used to relieve pressure and soften the dent">
                <div class="card-body">
                  <p class="card-text small">A blending hammer is first used to relieve pressure and soften the dent</p>
                </div>
              </div>
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/sequence-1.jpg" alt="A specialized hot glue is applied to a dent glue tab">
                <div class="card-body">
                  <p class="card-text small">A specialized hot glue is applied to a dent glue tab</p>
                </div>
              </div>
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/sequence-2.jpg" alt="The glue tab is then placed directly on the center of the dent and allowed to cure">
                <div class="card-body">
                  <p class="card-text small">The glue tab is then placed directly on the center of the dent and allowed to cure</p>
                </div>
              </div>
            </div>
            <div class="card-deck pt-4">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/sequence-3.jpg" alt="With the use of a slide hammer the dent can be pulled with the appropriate amount of force">
                <div class="card-body">
                  <p class="card-text small">With the use of a slide hammer the dent can be pulled with the appropriate amount of force</p>
                </div>
              </div>
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/sequence-4.jpg" alt="The glue tab is then released with a paint safe alcohol and cleanly finished with a blending hammer">
                <div class="card-body">
                  <p class="card-text small">The glue tab is then released with a paint safe alcohol and cleanly finished with a blending hammer</p>
                </div>
              </div>
            </div>
            <h2 id="blending" ref="blending">Blending</h2>
            <p>
              Blending refers to using a specialty hammer to manipulate the metal. The hammer is typically small and light weight with a highly polished head that will resist marking the clear coat. With the hammer a highly skilled technician can carefully make precision strikes that can relieve pressure, knockdown or re-contour the panel. This method is usually combined with glue pulling and/or using a tool to finish out the detail work when completing a dent. Where there is no access, small shallow dents can be repaired completely using just the hammer.
            </p>
            <h2 id="texture-correction" ref="texture-correction">Texture Correction</h2>
            <p>
              Texture correction refers to repairing or blending the clear coat thickness and texture. On very large dents it is necessary to lightly wet sand the clear coat to match the texture after it has been stressed. After wet sanding the area it will then be buffed and polished to remove scuff marks. This method can also be applied to poor prior PDR, neglected finish before performing PDR and removing scuff marks from knockdown or hammer. Buffing and polishing is also necessary to remove any marks or scratches before and after performing PDR for door ding and minor collision.
            </p>
            <h2 id="corrosion-protection" ref="corrosion-protection">Corrosion Protection</h2>
            <p>
              In the event that an access hole is stressed and the paint is compromised it is necessary to apply corrosion protection. Over the years and in our travels we rarely see a PDR technician that actually applies corrosion protection. If you look at your insurance estimate they always pay for corrosion protection, they don't want to be responsible if your car starts to rust after it has been worked on. Unfortunately the rust doesn't start to take hold until months or years after the repair has been performed and by that time it is too late. Below are photos of rust starting to take over years after someone performed poor PDR practices. Wherever a tool makes contact with a panels' access point, it should always be treated with corrosion protection. This is especially important for those who drive in areas where salt is applied to the road.
            </p>
            <div class="card-deck">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/corrosion-0.jpg" alt="Special tools are used to reach dents over panel braces">
                <div class="card-body">
                  <p class="card-text small">This vehicle was not treated with proper Corrosion Protection after repairs</p>
                </div>
              </div>
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/corrosion-1.jpg" alt="Access holes were left damaged by an unskilled PDR technician">
                <div class="card-body">
                  <p class="card-text small">Access holes were left damaged by an unskilled PDR technician</p>
                </div>
              </div>
            </div>
            <h2 id="push-to-paint" ref="push-to-paint">Push to Paint</h2>
            <p>
              In the event that the paint has been damaged from being stretched or from sharp impact, PDR may still be the preferred method to repair the dent. After the PDR has been performed the damaged area can then either be primed and painted or may still require a minimal amount of body filler before being refinished. This method is commonly referred to as "Push to Paint".
            </p>
            <h2 id="drilling-policy" ref="drilling-policy">Drilling Policy</h2>
            <p>
              We have a strict no drilling policy for hail damage. Up until the last decade it was quite popular for PDR technicians to drill holes into the underside of body panels. Apparently they didn't realize that metal is there for structural reasons. We will never drill to gain access to a panel on any hail damaged vehicle. In rare circumstances for door ding or minor collision damage it may be necessary to drill for access to successfully complete the repair. In these rare situations all options are presented to the vehicle owner and drilling is at their discretion.
            </p>
            <hr>
            <h1 class="display-4" id="claim-assistance" ref="claim-assistance">Claim Assistance</h1>
            <h2 id="submitting-a-hail-claim" ref="submitting-a-hail-claim">Submitting a Hail Claim</h2>
            <p>
              Choosing a repairer before filing a claim has its many benefits. Having a hail repair specialist on your side can save you time and stress when a storm strikes. An estimate can be written correctly the first time if your repairer is present during the insurance estimate. Most of the time, repair facilities can usually handle the entire process after the insured files a claim through their insurance company. Prior to the initial damage evaluation by your insurance agent, your repairer can make a thorough estimation for the cost of repairs using a special light to count and measure all of the hail dents.
            </p>
            <p>
              If you have already made a claim and have had an estimate written by your insurance provider it is a simple process for us to acquire a supplement if more damage is found during our estimation process.
            </p>
            <p>
              If you have never filed a hail claim before or you are unfamiliar with the process, the procedure is broken down in detail below. It is important to note that all auto insurance falls under two distinct categories, Collision and Comprehensive policies. Your 'Collision Policy' covers expenses due to an accident when you are at fault. Depending on your policy your rates can raise substantially depending on the amount of claims submitted from auto accidents where you are at fault. However, your 'Comprehensive Policy' protects you from expenses caused by situations out of your control. These situations are often referred to acts of &quot;God&quot; or &quot;nature&quot; depending on how your policy is worded. Because these situations, like a hail storm, are out of your control the damages are covered under your 'Comprehensive Policy' and you are not at fault. Your Collision and Comprehensive deductibles may differ depending on your policy choices.
            </p>
            <p>
              Your insurance provider will not raise your rates due to a hail claim since it falls under your 'Comprehensive Policy'.
            </p>
            <p>
              It is not beneficial to wait until the end of the hail season to file a claim. If there are multiple hail storms before you file a claim the damage may be so severe that it could actually affect the value of your vehicle. More panels may need to be replaced versus repaired which could lead to a total loss or diminished value after repairs, neither are desirable situations.
            </p>
            <h2 id="hail-claim-procedure" ref="hail-claim-procedure">Hail Claim Procedure</h2>
            <p>
              1. It is never too soon to submit a claim, as soon as the storm strikes and damage is found you should file a claim. Your insurance provider will ask you at what time and location the storm happened. Most major insurance providers now have Apps that make the claim submission effortless right from your smartphone. It is important to advise your provider if you have any broken glass or water leaking. In some extreme cases the vehicle may not be driveable and will need to be towed.
            </p>
            <p>
              2. Within 24 hours your insurance provider should respond and provide available dates and times for an inspection. If the storm was widespread they may request that you visit a catastrophe claim drive, a common practice for many major insurance providers. They may also refer you to an affiliated body shop to have an adjuster inspect the damage. Ultimately you can always have an adjuster sent to your residence for an estimate by request.
            </p>
            <p>
              Please note, if you are sent to a body shop for an estimate the shop will want your business. In many situations these &quot;pro-shops&quot; that are affiliated with your insurance provider aren't the best choice. Often work is performed at a lower rate and more aftermarket parts are used saving the insurance provider money, which is why they are the &quot;preferred shops&quot;. Paintless dent repair performed at these shops are usually performed by out-of-state PDR brokers and quality is always a gamble. Please do your research on who will be repairing your vehicle if you choose one of these shops and review their PDR warranty carefully.
            </p>
            <p>
              3. Once the damage inspection is complete you will receive a printed copy of the estimate to repair and a check for the total amount less the deductible. The deductible can also be referred to as the customer responsibility, the insurance will pay for the remainder of the repair. The deductible is due when the vehicle repairs are complete. Typically deductibles range from $0.00 to $1000.00 depending on your policy choice.
            </p>
            <p>
              4. The next step is choosing a hail damage specialist to repair your vehicle. Before your repairer starts on the vehicle a final estimate will be written. Usually damage is missed during the initial inspection. In most cases your repairer will use a special light to ensure that every dent is counted for. Typically this light isn't used during the initial estimate written by your insurance provider and a significant amount of damage is missed. A supplement request is then submitted by your repairer to the insurance provider, once the request is approved work can then begin on the vehicle.
            </p>
            <div class="card-deck pb-5">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/hail-claim.jpg" alt="Special tools are used to reach dents over panel braces">
                <div class="card-body">
                  <p class="card-text small">This panel has hundreds of dents that cannot be seen in most light conditions with the naked eye. All of the dents will need to be repaired so it is important to have an accurately written estimate.</p>
                </div>
              </div>
            </div>
            <hr>
            <h1 class="display-4" id="mobile-services" ref="mobile-services">Mobile Services</h1>
            <p class="lead">Your vehicle repaired at the comfort of your own home or office.</p>
            <h2 id="about-mobile-services" ref="about-mobile-services">About</h2>
            <p>
              With the advancements of PDR tools and techniques, most hail damaged vehicles can be repaired without the need of a body shop.
            </p>
            <p>
              Unless the paint was damaged due to extra large hail most vehicles can be completely repaired using paintless dent repair. Since each dent is repaired 100% by hand the required equipment and tools are minimal. Once on location for repairs, complete setup time is approximately 30 minutes making PDR a very efficient and effective method . Repairs can be performed in virtually any garage or location with our provided canopy (weather permitting).
            </p>
            <p>
              If your windshield/glass is damaged from hail we can arrange to have it replaced immediately on-site or replace it during the PDR process. Damaged chrome moldings, lights and trim pieces can be ordered prior to repairs and replaced during the PDR process. Your entire vehicle can be completely restored to pre-storm condition right at your home or office. All done without ever exposing your vehicle to a dusty body shop. Depending on the severity of the damage most vehicles are completed within 1-2 days. We can also arrange a rental vehicle if needed.
            </p>
            <h2 id="mobile-repair-procedure" ref="mobile-repair-procedure">Repair Procedure</h2>
            <ol>
              <li>405 PDR will estimate your vehicle for repairs and work with your insurance provider to ensure accuracy of the estimate.</li>
              <li>All necessary parts will be ordered prior to repairs and a repair date is scheduled. 405 PDR only uses O.E.M. parts directly from the manufacturer. Some insurance policies allow for aftermarket parts, we can review your policy and discuss part options during the estimating process.</li>
              <li>On the day of repairs it is not necessary for someone to be present however, keys will be needed to operate windows, sunroof etc.</li>
              <li>After all of the dents have been repaired and trim parts replaced your vehicle's exterior will be detailed by hand before a final quality inspection.</li>
              <li>After a final quality inspection repairs are complete and cleanup time is typically 30 minutes. Your vehicle will be restored without ever having to step foot into a shop!</li>
            </ol>
            <div class="card-deck pb-5">
              <div class="card text-dark bg-light">
                <img class="card-img-top" src="../assets/services/mobile.jpg" alt="Dents are massaged back out from the underside of the panel">
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-xl-block col-xl-2 side-nav">
          <ul class="section-nav">
            <li class="nav-entry">
              <a @click="goto('paintless-dent-repair')">
                Paintless Dent Repair
              </a>
              <ul>
                <li class="nav-entry">
                  <a @click="goto('tools')">
                    Tools
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('glue-pulling')">
                    Glue Pulling
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('blending')">
                    Blending
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('texture-correction')">
                    Texture Correction
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('corrosion-protection')">
                    Corrosion Protection
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('push-to-paint')">
                    Push to Paint
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('drilling-policy')">
                    Drilling Policy
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-entry">
              <a @click="goto('claim-assistance')">
                Claim Assistance
              </a>
              <ul>
                <li class="nav-entry">
                  <a @click="goto('submitting-a-hail-claim')">
                    Submitting a Hail Claim
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('hail-claim-procedure')">
                    Hail Claim Procedure
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-entry">
              <a @click="goto('mobile-services')">
                Mobile Services
              </a>
              <ul>
                <li class="nav-entry">
                  <a @click="goto('about-mobile-services')">
                    About
                  </a>
                </li>
                <li class="nav-entry">
                  <a @click="goto('mobile-repair-procedure')">
                    Repair Procedure
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesBanner from '@/components/ServicesBanner'
export default {
  name: 'ServicesPage',
  components: {
    ServicesBanner
  },
  methods: {
    goto (ref) {
      const navbar = document.getElementById('services-page-top').offsetTop
      const banner = document.getElementById('services-page-container').offsetTop
      const content = this.$refs[ref]
      const additional = content.tagName === 'H1' ? 20 : 80
      window.scrollTo(0, navbar + banner + content.offsetTop + additional)
    }
  },
  mounted: function () {
    if (this.$route.hash) {
      this.goto(this.$route.hash.slice(1))
    } else {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  padding-top: 4rem;
  padding-bottom: .5rem;
}
hr {
  border-color: white;
  padding-bottom: 3rem;
  margin-top: 2rem;
}
ol li {
  padding-bottom: 1rem;
}
ul li {
  cursor: pointer;
}
.nav-entry {
  display: block
}
.nav-entry a {
  display: block;
  padding: .125rem 1.5rem;
  color: #99979c
}
.nav-entry a:hover {
  color: #ffc107;
  text-decoration: none
}
.page {
  padding-top: 8rem;
}
.side-nav {
  -ms-flex-order: 2;
  order: 2;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-size: .875rem
}
@supports ((position:-webkit-sticky) or (position:sticky)) {
  .side-nav {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    height: calc(100vh - 4rem);
    overflow-y: auto
  }
}
.section-nav {
  padding-left: 0;
  border-left: 1px solid #eee
}
.section-nav ul {
  padding-left: 1rem
}
.section-nav ul ul {
  display: none
}
</style>



// WEBPACK FOOTER //
// src/components/ServicesPage.vue